var v1="<div>  <hr ng-class=\"{'horizontalLine': !settings.color}\"/> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaSpacer/lbaSpacer.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaSpacer/lbaSpacer.html
// module id = 437
// module chunks = 0